import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import user from '@/store/user';
import news from '@/store/news';
import Api from '@/services/api';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const dataState = createPersistedState({ key: 'pilihlaptop' });

export default new Vuex.Store({
  strict: debug,

  plugins: [dataState],

  state: {
    locale: 'id',
    isSmallScreen: false,
    compare: [],
    specifications: {
      timestamp: null,
      items: [],
    },
    specificationsRaw: {
      timestamp: null,
      items: [],
    },
  },

  mutations: {
    SET_LOCALE(state, locale) {
      state.locale = locale;
    },

    SET_SMALL_SCREEN(state, payload) {
      state.isSmallScreen = payload;
    },

    ADD_COMPARE_ITEM(state, payload) {
      state.compare.push(payload);
    },

    REMOVE_COMPARE_ITEM(state, index) {
      state.compare.splice(index, 1);
    },

    CLEAR_COMPARE_ITEM(state, notice) {
      state.compare = [];
      if (!notice) return;
      Vue.$toast('Compare emptied');
    },

    SET_SPECIFICATIONS(state, payload) {
      state.specifications = payload;
    },

    SET_SPECIFICATIONS_RAW(state, payload) {
      state.specificationsRaw = payload;
    },
  },

  actions: {
    setSmallScreen({ commit }) {
      commit('SET_SMALL_SCREEN', document.documentElement.clientWidth <= 768);
    },

    addCompareItem({ commit, state }, payload) {
      const { compare } = state;

      if (compare.length > 2) {
        Vue.$toast.warning('Compare slot full');
        return;
      }
      const index = compare.indexOf(payload);

      if (index < 0) {
        commit('ADD_COMPARE_ITEM', payload);
        Vue.$toast.success('Added to compare');
      } else {
        Vue.$toast.warning('Item already added');
      }
    },

    removeCompareItem({ commit, state }, payload) {
      const index = state.compare.indexOf(payload);
      commit('REMOVE_COMPARE_ITEM', index);
    },

    async getSpecifications({ commit }) {
      const params = {
        show: 40,
      };

      const res = await Api().get('specifications', { params })
        .then((res) => res.data.data.result.data);

      const items = res.map((el) => ({
        name: el.name,
        slug: el.slug,
        options: el.children.map((item) => ({
          name: item.name,
          value: item.id,
        })),
      }));

      const timestamp = Vue.prototype.$day().unix();

      const specsData = {
        timestamp,
        items,
      };

      const specsRaw = {
        timestamp,
        items: res,
      };

      commit('SET_SPECIFICATIONS_RAW', specsRaw);
      commit('SET_SPECIFICATIONS', specsData);
    },
  },

  modules: {
    user,
    news,
  },
});
